import { Button } from 'antd';
import { useTranslate } from '@tolgee/react';
import styled from '@emotion/styled';
import { ButtonProps } from 'antd/es/button';

const ButtonDisabled = styled(Button)`
  color: #b5b9bf !important;
`;

/** 撤回争议; */
const DisputeRetract = (props: Omit<ButtonProps, 'onClick'>) => {
  const { t } = useTranslate();

  return (
    <ButtonDisabled size="small" title={t('trade.暂不支持操作提示')} disabled {...props}>
      {t('trade.撤回争议')}
    </ButtonDisabled>
  );
};

export default DisputeRetract;
